export default {
  // —— Console/Admin OpenAPI ——
  'pages.openapi.overview.title': 'Resum de la plataforma oberta',
  'pages.openapi.overview.loadFailed': 'No s\'ha pogut carregar el resum d\'ús (és possible que l\'API encara no estigui a punt)',
  'pages.openapi.overview.docsTitle': 'Guia d\'integració',
  'pages.openapi.overview.docsDesc':
    'BasePath de la plataforma oberta: /v1. Sobre de resposta: {code,message,data,request_id}. Per a API Keys envieu Authorization: Bearer sk_live_... / sk_test_.... La clau en text pla només es mostra un cop en crear o rotar; deseu-la de manera segura.',
  'pages.openapi.overview.level': 'Nivell actual',
  'pages.openapi.overview.qps': 'Límit QPS',
  'pages.openapi.overview.apps': 'Apps',
  'pages.openapi.overview.appsSuffix': '(màx. {maxApps}, claus per app {maxKeys})',
  'pages.openapi.status.active': 'Actiu',
  'pages.openapi.status.disabled': 'Desactivat',
  'pages.openapi.apps.title': 'Apps i claus',
  'pages.openapi.apps.listTitle': 'Les meves apps',
  'pages.openapi.apps.create': 'Crear app',
  'pages.openapi.apps.createModal': 'Crear app',
  'pages.openapi.apps.name': 'Nom de l\'app',
  'pages.openapi.apps.nameRequired': 'Introduïu un nom',
  'pages.openapi.apps.description': 'Descripció',
  'pages.openapi.apps.status': 'Estat',
  'pages.openapi.apps.createdAt': 'Creat el',
  'pages.openapi.apps.createSuccess': 'App creada',
  'pages.openapi.apps.createFailed': 'Error en crear l\'app',
  'pages.openapi.apps.loadFailed': 'Error en carregar les apps',
  'pages.openapi.apps.keysLoadFailed': 'Error en carregar les claus',
  'pages.openapi.apps.delete': 'Eliminar',
  'pages.openapi.apps.deleteConfirm': 'Voleu eliminar aquesta app?',
  'pages.openapi.apps.deleted': 'Eliminada',
  'pages.openapi.apps.createKey': 'Crear Key',
  'pages.openapi.apps.createKeyModal': 'Crear API Key',
  'pages.openapi.apps.keyCreateSuccess': 'Clau creada',
  'pages.openapi.apps.keyCreateFailed': 'Error en crear la clau',
  'pages.openapi.apps.noPlainKey': 'No s\'ha retornat cap clau en text pla',
  'pages.openapi.apps.plainKeyTitle': 'Deseu la vostra API Key',
  'pages.openapi.apps.plainKeyHint': 'El text pla només es mostra un cop i no es podrà tornar a veure després de tancar.',
  'pages.openapi.apps.copy': 'Copia',
  'pages.openapi.apps.copied': 'Copiat',
  'pages.openapi.apps.copyFailed': 'Error en copiar; seleccioneu-ho manualment',
  'pages.openapi.apps.close': 'Tanca',
  'pages.openapi.apps.key.name': 'Nom',
  'pages.openapi.apps.key.namePlaceholder': 'Clau principal de producció',
  'pages.openapi.apps.key.prefix': 'Prefix',
  'pages.openapi.apps.key.env': 'Entorn',
  'pages.openapi.apps.key.status': 'Estat',
  'pages.openapi.apps.key.createdAt': 'Creat el',
  'pages.openapi.apps.key.disable': 'Desactiva',
  'pages.openapi.apps.key.disableConfirm': 'Voleu desactivar aquesta clau?',
  'pages.openapi.apps.key.disabled': 'Desactivada',
  'pages.openapi.apps.key.enable': 'Activa',
  'pages.openapi.apps.key.enabled': 'Activada',
  'pages.openapi.apps.key.rotate': 'Rota',
  'pages.openapi.apps.key.rotateConfirm': 'La rotació genera una clau nova i retorna el text pla un sol cop. Continuar?',
  'pages.openapi.apps.key.rotated': 'Rotada',
  'pages.openapi.apps.key.delete': 'Eliminar',
  'pages.openapi.apps.key.deleteConfirm': 'Voleu eliminar aquesta clau? No es pot desfer.',
  'pages.openapi.apps.key.deleted': 'Eliminada',
  'pages.openapi.logs.title': 'Registres d\'ús',
  'pages.openapi.logs.listTitle': 'Detalls de les crides',
  'pages.openapi.logs.dailyTitle': 'Ús dels darrers 14 dies',
  'pages.openapi.logs.dailyEmpty': 'Sense dades d\'ús diari',
  'pages.openapi.logs.date': 'Data',
  'pages.openapi.logs.count': 'Crides',
  'pages.openapi.logs.createdAt': 'Hora',
  'pages.openapi.logs.requestId': 'Request ID',
  'pages.openapi.logs.requestIdPlaceholder': 'Enganxeu el request_id de la resposta de l\'API',
  'pages.openapi.logs.detail': 'Detalls',
  'pages.openapi.logs.detailTitle': 'Detalls de la crida',
  'pages.openapi.logs.detailLoading': 'S\'està carregant…',
  'pages.openapi.logs.requestQuery': 'Query',
  'pages.openapi.logs.requestBody': 'Petició',
  'pages.openapi.logs.responseBody': 'Resposta',
  'pages.openapi.logs.app': 'App',
  'pages.openapi.logs.appId': 'ID d\'app',
  'pages.openapi.logs.apiKey': 'API Key',
  'pages.openapi.logs.userId': 'ID d\'usuari',
  'pages.openapi.logs.apiKeyId': 'Key ID',
  'pages.openapi.logs.keyPrefix': 'Prefix Key',
  'pages.openapi.logs.method': 'Mètode',
  'pages.openapi.logs.path': 'Camí',
  'pages.openapi.logs.statusCode': 'HTTP',
  'pages.openapi.logs.code': 'Codi de negoci',
  'pages.openapi.logs.latency': 'Latència (ms)',
  'pages.openapi.logs.loadFailed': 'Error en carregar',
  'pages.openapi.planTiers.title': 'Plans de la plataforma oberta',
  'pages.openapi.planTiers.level': 'Nivell',
  'pages.openapi.planTiers.levelTip':
    'Plan tier level (1–5), aligned with the user profile Level. Higher numbers mean higher tiers.',
  'pages.openapi.planTiers.name': 'Nom',
  'pages.openapi.planTiers.qps': 'QPS',
  'pages.openapi.planTiers.qpsTip':
    'Max requests per second (Queries Per Second). Default rate limit for API Key calls on this tier: sustained rate equals this value; burst capacity is about QPS×2 (at least 5). Applies only to API Key calls; console/admin traffic is not counted. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42901).',
  'pages.openapi.planTiers.dailyQuota': 'Quota diària',
  'pages.openapi.planTiers.dailyQuotaTip':
    'Max total API requests allowed per calendar day. Counted per user/key; only API Key calls count. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42902).',
  'pages.openapi.planTiers.maxApps': 'Màx. d\'apps',
  'pages.openapi.planTiers.maxAppsTip':
    'Maximum number of OpenAPI apps a developer on this tier can create.',
  'pages.openapi.planTiers.maxKeys': 'Màx. de claus per app',
  'pages.openapi.planTiers.maxKeysTip': 'Maximum number of API keys allowed under each app.',
  'pages.openapi.planTiers.allowedScopes': 'Allowed permissions (scopes)',
  'pages.openapi.planTiers.allowedScopesTip':
    'API permission scopes this tier may request or be granted. App and API Key scopes must be a subset of this selection.',
  'pages.openapi.planTiers.save': 'Desa',
  'pages.openapi.planTiers.saved': 'Desat',
  'pages.openapi.planTiers.saveFailed': 'Error en desar',
  'pages.openapi.planTiers.loadFailed': 'Error en carregar els plans',
  'pages.openapi.planTiers.readonly': 'Els observadors només tenen lectura i no poden editar els plans',
  'pages.openapi.admin.usageLogsTitle': 'Auditoria de crides de la plataforma oberta',
  'pages.openapi.admin.usageLogsList': 'Registres globals de crides',
  'pages.openapi.admin.disableKeyConfirm': 'Voleu desactivar aquesta API Key?',
  'pages.openapi.admin.disableKey': 'Desactiva Key',
  'pages.openapi.admin.keyDisabled': 'Desactivada',
  'pages.openapi.admin.appsTitle': 'Apps de la plataforma oberta',
  'pages.openapi.admin.appsList': 'Totes les apps de desenvolupador',
  'pages.openapi.admin.developers': 'Desenvolupadors',
  'pages.openapi.admin.apps': 'Apps',
  'pages.openapi.admin.keys': 'Claus totals',
  'pages.openapi.admin.activeKeys': 'Claus actives',
  'pages.openapi.admin.todayRequests': 'Crides d\'avui',
  'pages.openapi.admin.todayErrors': 'Errors d\'avui',
  'pages.openapi.admin.errorCount': 'Errors',
  'pages.openapi.admin.owner': 'Propietari',
  'pages.openapi.admin.keyCount': 'Claus',
  'pages.openapi.admin.keyword': 'Paraula clau',
  'pages.openapi.admin.keywordPlaceholder': 'Nom d\'app / descripció / codi de llogater',
  'pages.openapi.admin.statsLoadFailed': 'Error en carregar estadístiques',
  'pages.openapi.admin.noKeys': 'Sense claus',
  'pages.openapi.admin.appEnabled': 'App activada',
  'pages.openapi.admin.appDisabled': 'App desactivada',
  'pages.openapi.admin.appDisableConfirm': 'Voleu desactivar aquesta app?',
  'pages.openapi.admin.appEnableConfirm': 'Voleu activar aquesta app?',
  'pages.openapi.admin.keyEnableConfirm': 'Voleu activar aquesta clau?',
  'pages.admin.user.openapiDeveloperEnabled': 'Plataforma oberta',
  'pages.admin.user.openapi.on': 'Activat',
  'pages.admin.user.openapi.off': 'Desactivat',
  'pages.admin.user.openapiLevel': 'Nivell de plataforma oberta',
  'pages.admin.user.openapiDeveloperEnabled.label': 'Activar desenvolupador',
  'pages.admin.user.openapiLevel.label': 'Nivell',
  'pages.admin.user.openapiLevel.placeholder': '1-5',
  'pages.openapi.overview.dailyUsage': 'Ús d\'avui',
  'pages.openapi.apps.key.enableConfirm': 'Voleu activar aquesta clau?',
  'pages.admin.user.section.openapi': 'Plataforma oberta',
};
